import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { signInWithRedirect } from 'aws-amplify/auth';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { AuthProvider } from './hooks/AuthContext';
import Dashboard from './components/Dashboard';
import Automations from './components/Automations';
import AutomationView from './components/AutomationView';
import Chat from './components/Chat';
import Monitor from './components/Monitor';
import Requests from './components/Requests';
import RequestView from './components/RequestView';
import Settings from './components/Settings';
import Users from './components/Users';
import UserProfile from './components/UserProfile';
import Changelog from './components/Changelog';
import Integrations from './components/Integrations';
import Deployments from './components/Deployments';
import Cleanup from './components/Cleanup';
import Reports from './components/Reports';
import Outreach from './components/Outreach';
import AiOpportunities from './components/AiOpportunities';
import Navigation from './components/Navigation';
import ChatBubble from './components/ChatBubble';
import ProtectedRoute from './components/ProtectedRoute';
import RoleSwitcher from './components/RoleSwitcher';
import './App.css';

function App() {
  return (
    <Authenticator 
      hideSignUp={true}
      components={{
        SignIn: {
          Header() {
            return (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Sign in to Automunity</h2>
                <button 
                  onClick={() => signInWithRedirect({ provider: { custom: 'azure' } })}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#0078d4',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  Sign in with Azure AD
                </button>
              </div>
            );
          }
        }
      }}
    >
      {({ signOut, user }) => (
        <AuthProvider>
          <Router>
            <div className="App">
              <Navigation user={user} signOut={signOut} />
              <div className="main-content">
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<ProtectedRoute page="dashboard"><Dashboard /></ProtectedRoute>} />
                  <Route path="/automations" element={<ProtectedRoute page="automations"><Automations /></ProtectedRoute>} />
                  <Route path="/automations/view/:id" element={<ProtectedRoute page="automations"><AutomationView /></ProtectedRoute>} />
                  <Route path="/chat" element={<ProtectedRoute page="chat"><Chat /></ProtectedRoute>} />
                  <Route path="/monitor" element={<ProtectedRoute page="monitor"><Monitor /></ProtectedRoute>} />
                  <Route path="/requests" element={<ProtectedRoute page="requests"><Requests /></ProtectedRoute>} />
                  <Route path="/requests/:id" element={<ProtectedRoute page="requests"><RequestView /></ProtectedRoute>} />
                  <Route path="/settings" element={<ProtectedRoute page="settings"><Settings /></ProtectedRoute>} />
                  <Route path="/users" element={<ProtectedRoute page="users"><Users /></ProtectedRoute>} />
                  <Route path="/users/:id" element={<ProtectedRoute page="users"><UserProfile /></ProtectedRoute>} />
                  <Route path="/changelog" element={<ProtectedRoute page="changelog"><Changelog /></ProtectedRoute>} />
                  <Route path="/deployments" element={<ProtectedRoute page="deployments"><Deployments /></ProtectedRoute>} />
                  <Route path="/cleanup" element={<ProtectedRoute page="cleanup"><Cleanup /></ProtectedRoute>} />
                  <Route path="/integrations" element={<ProtectedRoute page="integrations"><Integrations /></ProtectedRoute>} />
                  <Route path="/integrations/:provider" element={<ProtectedRoute page="integrations"><Integrations /></ProtectedRoute>} />
                  <Route path="/reports" element={<ProtectedRoute page="reports"><Reports /></ProtectedRoute>} />
                  <Route path="/outreach" element={<ProtectedRoute page="outreach"><Outreach /></ProtectedRoute>} />
                  <Route path="/ai-opportunities" element={<ProtectedRoute page="ai-opportunities"><AiOpportunities /></ProtectedRoute>} />
                </Routes>
              </div>
              <RoleSwitcher />
              <ChatBubble />
            </div>
          </Router>
        </AuthProvider>
      )}
    </Authenticator>
  );
}

export default App;
